import { GlobalFulfillmentLimit, PerMemberFulfillmentLimit } from '@occc/feat-limits';
import { Stack } from '@mui/material';

import { Divider } from '@occc/ui-design-system';
import { VoucherExpirationDaysRedemption } from '@occc-app/routes/CampaignComponents/VoucherExpirationDaysRedemption';
import { Offer_Engagement_Type } from '@occc/graphql';

import { ConfigureFormValues } from '../types';

type RedemptionProps = {
  values: Pick<ConfigureFormValues, 'awardCount' | 'awardVouchers'>;
};

export const Redemption = ({ values }: RedemptionProps) => {
  const isVoucherRedemptionShown =
    values.awardVouchers?.voucheredOffer?.engagementType === Offer_Engagement_Type.Vouchered;
  const isVoucherRedemptionApplicable =
    values.awardVouchers?.voucheredOffer?.engagementType === Offer_Engagement_Type.Vouchered;
  const isVoucherRedemptionEnabled = values.awardVouchers?.isEnabled ?? false;

  return (
    <Stack divider={<Divider />}>
      {isVoucherRedemptionShown && (
        <VoucherExpirationDaysRedemption
          isVoucherRedemptionEnabled={isVoucherRedemptionEnabled}
          isVoucherRedemptionApplicable={isVoucherRedemptionApplicable}
          showAvatar
        />
      )}

      <PerMemberFulfillmentLimit
        open={values?.awardCount?.membership?.isEnabled}
        title='Per Member Redemption Limit'
        description=''
        showAvatar
      />

      <GlobalFulfillmentLimit
        open={values?.awardCount?.global?.isEnabled}
        title='Global Redemption Limit'
        description=''
        showAvatar
      />
    </Stack>
  );
};
